import { FetchVariablesParams } from '@/types/api/params/fetchVariablesParams';
import { convertCreateChangeInfo, convertHtmlToText } from './commonTypeConverter';
import { CreateTemplateRequest, CreateVariableRequest } from '@/types/api/request/createTemplateTypes';

export interface Template {
	template_name: string;
	template_status: string;
	variables: { entities: Array<Variable> };
	createdby: string;
	createddate: string;
	changeby: string;
	changedate: string;
	body: string;
}

export interface Variable {
	variable: NotificationVariable;
}

export interface NotificationVariable {
	id: number;
	max_char: number;
	default_value: string;
	name: string;
}

export function convertTemplate(template: Template) {
	const createChangeInfo = convertCreateChangeInfo(template);

	return {
		...createChangeInfo,
		name: template.template_name,
		templateStatus: template.template_status,
		variables: template.variables.entities.map((variable) => convertVariable(variable.variable)),
		mailText: template.body,
		smsText: convertHtmlToText(template.body),
	};
}

export function convertVariable(variable: NotificationVariable) {
	return {
		id: variable.id,
		name: variable.name,
		defaultValue: variable.default_value,
		maxChar: variable.max_char,
	};
}

export function convertVariableRequest(variable?: FetchVariablesParams) {
	return variable
		? {
				pageSize: variable.size,
		  }
		: {
				unPaged: true,
		  };
}

export function convertTemplateRequest(template: CreateTemplateRequest) {
	return {
		...(template.id && { id: template.id }),
		template_name: template.name,
		template_status: template.templateStatus,
		...(template.templateGroupId && { template_group_id: template.templateGroupId }),
		body: template.mailText,
	};
}

export function convertCreateVariableRequest(variable: CreateVariableRequest) {
	return {
		name: variable.name,
		default_value: variable.defaultValue,
		max_char: variable.maxChar,
	};
}
